import type { GoalConfig, GoalSource } from "../lib/goal-form-types";

// F6: goals.config differs per `source`. This renders only the fields
// relevant to the currently selected source (Suzuki Sekkotsuin example:
// source=ga4_event, ga4EventName='line_tap' / 'reserve_tap' / 'tel_tap').
export function GoalConfigFields({
  config,
  onChange,
}: {
  config: GoalConfig;
  onChange: (next: GoalConfig) => void;
}) {
  switch (config.source) {
    case "ga4_event":
      return (
        <div>
          <label className="block text-sm text-gray-700 mb-1" htmlFor="ga4-event-name">
            GA4イベント名
          </label>
          <input
            id="ga4-event-name"
            required
            value={config.ga4EventName}
            onChange={(e) => onChange({ ...config, ga4EventName: e.target.value })}
            placeholder="例: line_tap / reserve_tap / tel_tap"
            className="w-full rounded border border-gray-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <p className="text-xs text-gray-500 mt-1">
            既存のGTM/GA4で発火済みのイベント名を指定します（dataLayerを購読して相乗り検知）。
          </p>
        </div>
      );
    case "selector":
      return (
        <div>
          <label className="block text-sm text-gray-700 mb-1" htmlFor="selector">
            CSSセレクタ
          </label>
          <input
            id="selector"
            required
            value={config.selector}
            onChange={(e) => onChange({ ...config, selector: e.target.value })}
            placeholder="例: #reserve-button"
            className="w-full rounded border border-gray-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <p className="text-xs text-gray-500 mt-1">
            GTM未導入サイト向け。指定要素のクリックをタグが自前で検知します。
          </p>
        </div>
      );
    case "url":
      return (
        <div className="space-y-3">
          <div>
            <label className="block text-sm text-gray-700 mb-1" htmlFor="goal-url">
              到達URL
            </label>
            <input
              id="goal-url"
              required
              value={config.url}
              onChange={(e) => onChange({ ...config, url: e.target.value })}
              placeholder="例: /thanks"
              className="w-full rounded border border-gray-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1" htmlFor="goal-url-match-type">
              一致方式
            </label>
            <select
              id="goal-url-match-type"
              value={config.matchType}
              onChange={(e) =>
                onChange({
                  ...config,
                  matchType: e.target.value as "exact" | "prefix" | "regex",
                })
              }
              className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <option value="exact">完全一致</option>
              <option value="prefix">前方一致</option>
              <option value="regex">正規表現</option>
            </select>
          </div>
          <p className="text-xs text-gray-500">SPA遷移もHistory APIで捕捉して検知します。</p>
        </div>
      );
    case "custom":
      return (
        <div>
          <label className="block text-sm text-gray-700 mb-1" htmlFor="goal-key">
            ゴールキー
          </label>
          <input
            id="goal-key"
            required
            value={config.goalKey}
            onChange={(e) => onChange({ ...config, goalKey: e.target.value })}
            placeholder="例: custom_signup"
            className="w-full rounded border border-gray-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <p className="text-xs text-gray-500 mt-1">
            ホスト側で <code>_hm.track(&apos;{config.goalKey || "goal_key"}&apos;)</code> を明示コールしてください。
          </p>
        </div>
      );
  }
}

export function defaultConfigFor(source: GoalSource): GoalConfig {
  switch (source) {
    case "ga4_event":
      return { source, ga4EventName: "" };
    case "selector":
      return { source, selector: "", event: "click" };
    case "url":
      return { source, url: "", matchType: "exact" };
    case "custom":
      return { source, goalKey: "" };
  }
}
